import { PdfEntityByAcademicYearList } from 'components/pdfStudent';
import { splitEntitiesByAcademicYear } from 'containers/pdfStudent/utils/splitEntitiesByAcademicYear';
import { useAppSelector, useDataLoad } from 'hooks';
import { IconWidgetScienceProjects } from 'icons/widgets';
import PdfNoDataText from 'portfolio3/features/pdf/components/PdfNoDataText';
import { chosenAcademicYearsListSelector } from 'portfolio3/features/pdf/model/selectors';
import { getDataLoadRequests } from 'utils';

import { scienceProjectsSelector } from '../../../../selectors';
import PdfCommonDataEntityContainer from '../common';

import '../index.scss';

const PdfScienceProjectContainer = () => {
  const academicYears = useAppSelector(chosenAcademicYearsListSelector);
  const studentProjects = useAppSelector(scienceProjectsSelector);
  useDataLoad({ shouldLoad: true, requests: getDataLoadRequests().scienceProjects });
  const hasData = studentProjects.content.length > 0;
  const academicYearData = splitEntitiesByAcademicYear(studentProjects, academicYears);
  return (
    <PdfCommonDataEntityContainer title="Проекты" Icon={IconWidgetScienceProjects}>
      {hasData && <PdfEntityByAcademicYearList academicYearData={academicYearData} />}
      {!hasData && <PdfNoDataText />}
    </PdfCommonDataEntityContainer>
  );
};

export default PdfScienceProjectContainer;
